<script setup lang="ts">
const props = defineProps({
  line1: String,
  line2: String,
})
</script>

<template>
  <div class="pt-12 md:pt-0">
    <div class="absolute z-0 w-full hidden lg:block space-y-20 lg:space-y-25 pt-9 h-short:space-y-24 h-short:pt-0 overflow-hidden">
      <div class="w-full border-b border-dashed border-gray-300 -relative z-10 invisible"></div>
      <div class="w-full border-b border-dashed border-gray-300 -relative z-10"></div>
      <div class="w-full border-b border-dashed border-gray-300 -relative z-10"></div>
    </div>
    <div class="relative z-10 px-6 md:px-0 py:0 md:py-16 h-short:py-12">
      <div
          class="text-[3.25rem] md:text-[5.625rem] lg:text-[6.875rem] h-short:text-[5.625rem] font-serif font-extrabold leading-none antialiased text-center mb-12 md:mb-0">
        <p class="relative z-20 mb-0 h-short:-translate-y-4.25 lg:-translate-y-2.25 -translate-x-15 md:-translate-x-30">{{ props.line1 }}</p>
        <p class="relative z-20 mb-0 h-short:-translate-y-2.5 lg:-translate-y-4.5 translate-x-12.5 md:translate-x-25">{{ props.line2 }}</p>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
